import {
  Avatar, Box, Card, CardActions, Divider, Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import BarChart from '../common/charts/BarChart';
import { ChevronUp as ChevronUpIcon } from '../../icons/chevron-up';
import style from './srtyle';

// TODO Mock
export default function PositionStatistics(): JSX.Element {
  return (
    <Card>
      <Box sx={ style.box }>
        <div>
          <Typography
            color="textSecondary"
            variant="body2"
          >
            Open Position
          </Typography>
          <Typography
            sx={ { mt: 1 } }
            variant="h5"
          >
            131,3K
          </Typography>
        </div>
        <BarChart seriesData={ [0, 60, 30, 60, 0, 30, 10, 30, 0] } />
      </Box>
      <Divider />
      <CardActions
        sx={ style.cardAction }
      >
        <Avatar
          sx={ {
            ...style.avatar,
            backgroundColor: (theme) => alpha(theme.palette.success.main, 0.08),
          } }
        >
          <ChevronUpIcon fontSize="small" />
        </Avatar>
        <Typography
          color="textSecondary"
          sx={ { ml: 1 } }
          variant="caption"
        >
          12% more then last week
        </Typography>
      </CardActions>
    </Card>
  );
}
